import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import EntityTypeService from '../services/EntityTypeService';
import { loadingEntityTypeDropdown } from '../store/slices/entityType/entityTypeSlice';

export const useEntityType = () => {
  const dispatch: AppDispatch = useDispatch();

  const { entityTypeDropdown } = useSelector(
    (state: RootState) => state.entityType
  );

  const fetchEntityTypeDropdown = async () => {
    try {
      const response = await EntityTypeService.fetchDropdown();
      dispatch(loadingEntityTypeDropdown(response));
    } catch (error) {
      console.error("Error al cargar entity types:", error);
    }
  };

  return {
    entityTypeDropdown,
    fetchEntityTypeDropdown,
  };
};
